import { createAction, createAsyncThunk } from '@reduxjs/toolkit';

import {
  httpGetWayMoreCategories,
  httpGetWayMoreProducts,
  httpGetWayMoreStores,
} from 'api';
import { getErrorText, showErrorMessage } from 'helpers';

const getWayMoreStores = createAsyncThunk(
  'waymore/getWayMoreStores',
  async () => {
    try {
      const { data } = await httpGetWayMoreStores();

      return data;
    } catch (error) {
      showErrorMessage(getErrorText());
      throw error;
    }
  },
);

const getWayMoreCategories = createAsyncThunk(
  'waymore/getWayMoreCategories',
  async ({ storeId }) => {
    try {
      const { data } = await httpGetWayMoreCategories(storeId);

      return data;
    } catch (error) {
      showErrorMessage(getErrorText());
      throw error;
    }
  },
);

const getWayMoreProducts = createAsyncThunk(
  'waymore/getWayMoreProducts',
  async ({ storeId, category }) => {
    try {
      const params = { 'return-deleted': false, 'category-name': category };

      const { data } = await httpGetWayMoreProducts(storeId, params);

      return data;
    } catch (error) {
      showErrorMessage(getErrorText());
      throw error;
    }
  },
);

const selectWayMoreStore = createAction('selectWayMoreStore');

const selectWayMoreCategory = createAction('selectWayMoreCategory');

const selectWayMoreProduct = createAction('selectWayMoreProduct');

const resetWayMoreProducts = createAction('resetWayMoreProducts');

export {
  getWayMoreStores,
  getWayMoreCategories,
  getWayMoreProducts,
  selectWayMoreStore,
  selectWayMoreCategory,
  selectWayMoreProduct,
  resetWayMoreProducts,
};
